import { ChannelsApi } from '@flipdish/api-client-typescript';
import axios from 'axios';

import { getApiEndPoint } from '../../helpers/apibase';
import { CredentialsAuth } from '../../helpers/utilities';
import { mapServerError } from '../../services/utils/serverErrorMapper';

const baseUrl = getApiEndPoint();

const portalApi = axios.create({
  baseURL: `${baseUrl}/api/v1.0`,
  withCredentials: true,
});

const api = new ChannelsApi(getApiEndPoint());
api.setDefaultAuthentication(new CredentialsAuth());

const getStores = async (appId: string, channelId: number) => {
  try {
    const incomingMessage = await api.getStoresBySalesChannel(appId, channelId);
    return incomingMessage.body.Stores;
  } catch (e) {
    throw mapServerError(e);
  }
};

const assignStoresToAppType = async (appId: string, channelId: number, storeId: number) => {
  try {
    await api.attachStoreToSalesChannel(appId, channelId, storeId);
  } catch (incomingMessage) {
    throw mapServerError(incomingMessage);
  }
};

const deleteStoreFromAppType = async (appId: string, channelId: number, storeId: number) => {
  try {
    await api.detachStoreFromSalesChannel(appId, channelId, storeId);
  } catch (incomingMessage) {
    throw mapServerError(incomingMessage);
  }
};

const detachAllStoresFromSalesChannel = async (appId: string, channelId: number) => {
  try {
    await api.detachAllStoresFromSalesChannel(appId, channelId);
  } catch (e) {
    throw mapServerError(e);
  }
};

export const salesChannelsServices = {
  assignStoresToAppType,
  getStores,
  deleteStoreFromAppType,
  detachAllStoresFromSalesChannel,
};
